<template>
  <cms-banner-image-standard v-bind="$props" />
</template>

<script lang="ts" setup>
import type { BannerImageContent } from '#types/components/cms/banner-image'

defineProps<{
  content: BannerImageContent
  paused?: boolean
  firstElement?: boolean
  /**
   * Whether this slide is currently active in a carousel
   */
  isActiveSlide?: boolean
}>()
</script>
